import { render, staticRenderFns } from "./Forgot-Password.vue?vue&type=template&id=7aaa433b"
import script from "./Forgot-Password.vue?vue&type=script&lang=js"
export * from "./Forgot-Password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports